import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { VehicleCardAddEdit, VehicleRegistrationListing } from './Pages';

export const VehicleRegistrationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={VehicleRegistrationListing} />
        <Route exact path={`${match.path}/vehicleCardAddEdit/:id?`} component={VehicleCardAddEdit} />
    </Fragment>
)